import React from "react";

export type User = undefined | null | firebase.User;

export const AuthContext = React.createContext<User>(undefined);
